export const formatCompliance = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return "--"
  return String(value)
}

export const roundCompliance = (value: number): number => {
  if (value < 1 || value > 99) return parseFloat(value.toFixed(2))
  return Math.round(value)
}
